export default {

  app: null,

  getVueRoot(){
    return this.app.$root;
  }

}
